<!-- 工效分析 -->
<template>
	<div class="main">
		<!-- 将查看详细工作记录提到工效分析页面上 -->
		<!-- <a-card>
			<div class="topBtn">
				<div class="saiBtn">
					<div v-for="(item, index) in btnList" :key="index" @click="btnClick(item.val)" class="hoverBtns on"
						:class="{ actives: activeType == item.val }">
						{{ item.title }}
					</div>
				</div>
				<div class="rightBtn">
					<div class="hoverBtns on" @click="exportData">导出表格</div>
					<div class="hoverBtns on" @click="goRecord">详细工作记录</div>
				</div>
			</div>
			<a-table :columns="columns" :data-source="tableData" bordered :pagination="false" rowKey="userId">
				<template slot="abnormal" slot-scope="scope">
					<span>{{ scope.tourSucceedCnt ? scope.tourSucceedCnt : 0 }}/{{
						scope.tourTotalCnt ? scope.tourTotalCnt : 0
					}}</span>
				</template>
			</a-table>
			<a-pagination v-model="pageNum" @change="pageChange" :total="total" :pageSize="20" :hideOnSinglePage="true"
				show-less-items style="text-align: center; margin-top: 20px" />
		</a-card> -->
	</div>
</template>

<script>
const columns = [
	{
		title: '姓名',
		dataIndex: 'name',
		width: '10%',
		align: 'center',
	},
	{
		title: '在线时长',
		dataIndex: 'onlineTime',
		width: '10%',
		align: 'center',
	},
	// {
	//   title: "巡查完成次数/巡查次数",
	//   width: "16%",
	//   align: "center",
	//   scopedSlots: { customRender: "abnormal" },
	// },
	// {
	//   title: "巡查平均用时",
	//   dataIndex: "tourSpendTime",
	//   width: "12%",
	//   align: "center",
	// },
	{
		title: '异常处理次数',
		dataIndex: 'eventProcCnt',
		width: '12%',
		align: 'center',
	},
	{
		title: '异常响应速度(平均)',
		dataIndex: 'eventWaitTime',
		width: '14%',
		align: 'center',
	},
	// {
	//     title: '异常处理时长(平均)',
	//     dataIndex: 'eventProcTime',
	//     width: '14%',
	//     align: 'center'
	// },
	{
		title: '漏掉异常次数',
		dataIndex: 'missAbnormalCnt',
		width: '12%',
		align: 'center',
	},
];

export default {
	data() {
		return {
			tableData: [],
			columns,
			btnList: [
				// 筛选列表
				{
					val: 1,
					title: '今天',
				},
				{
					val: 2,
					title: '昨天',
				},
				{
					val: 3,
					title: '过去7天',
				},
				{
					val: 4,
					title: '过去30天',
				},
			],
			activeType: 1, // 默认选择今天
			pageNum: 1, // 当前页
			pageSize: 20, // 每页默认20条
			total: 0,
			healthBigData: [
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
				{ enable: 0 },
			],
		};
	},
	created() { },
	mounted() {
		// 将查看详细工作记录提到工效分析页面上
		this.$router.push({
			path: '/dean/record',
		});
		return
		this.getHealthBigData();
		this.backTop();
		this.getTableData();
	},
	methods: {
		getHealthBigData() {
			this.$post(
				'api/health-big-data/select',
				{
					tenantId: this.$getCookie('userInfo').user.tenantId,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.healthBigData = res.data;
							if (this.healthBigData[4].enable != 1) {
								this.$router.replace('/dean/home');
							} else {
							}
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		backTop() {
			const that = this;
			let ispeed = Math.floor(-that.scrollTop / 5);
			document.documentElement.scrollTop = document.body.scrollTop =
				that.scrollTop + ispeed;
		},
		onChange(value) {
			console.log(value);
		},
		// 获取表格数据
		getTableData() {
			let param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				type: this.activeType,
			};
			this.$get(
				'/api/statis/nurseWork',
				param,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.tableData = res.data.records;
							this.total = res.data.total;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 筛选页面数据
		btnClick(val) {
			console.log(val);
			this.activeType = val;
			this.getTableData();
		},
		// 分页
		pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getTableData();
		},
		// 工作记录
		goRecord() {
			this.$router.push({
				path: '/dean/record',
			});
		},
		exportData() {
			this.$getExport(
				'/api/statis/export?type=' + this.activeType,
				{},
				(res) => {
					const blob = new Blob([res]);
					//根据选择的是哪天大报告，去获取日期显示在名字上
					if (this.activeType == 1 || this.activeType == 2) {
						var fileName =
							this.getDay(-this.activeType + 1, '-') + '工效分析.xlsx';
					} else if (this.activeType == 3) {
						var fileName =
							this.getDay(-7, '-') +
							'-' +
							this.getDay(-1, '-') +
							'工效分析.xlsx';
					} else if (this.activeType == 4) {
						var fileName =
							this.getDay(-30, '-') +
							'-' +
							this.getDay(-1, '-') +
							'工效分析.xlsx';
					} else {
						var fileName = '工效分析.xlsx';
					}
					//const fileName = "工效分析.xlsx";
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				}
			);
		},
		//获取日期
		getDay(num, str) {
			var today = new Date();
			var nowTime = today.getTime();
			var ms = 24 * 3600 * 1000 * num;
			today.setTime(parseInt(nowTime + ms));
			var oYear = today.getFullYear();
			var oMoth = (today.getMonth() + 1).toString();
			if (oMoth.length <= 1) oMoth = '0' + oMoth;
			var oDay = today.getDate().toString();
			if (oDay.length <= 1) oDay = '0' + oDay;
			return oYear + str + oMoth + str + oDay;
		},
	},
};
</script>
<style lang="scss" scoped>
.main::v-deep {
	width: 1180px;
	padding: 20px 0;

	.ant-card {
		padding: 15px 20px;
		border-radius: 8px;

		.ant-table-content {
			min-height: 1134px;
		}

		.ant-card-body {
			padding: 0;
		}

		.actives {
			background: #e6f7ff !important;
			color: #1890ff !important;
			border: 1px solid #e6f7ff !important;
		}

		.hoverBtns:hover {
			background: #ffffff !important;
			color: #1890ff !important;
			border: 1px solid #1890ff !important;
		}

		.ant-table-thead>tr>th {
			background: #f0f0f0;
		}

		.ant-table-tbody {
			.ant-table-row:nth-child(even) {
				background: #fafafa;
			}
		}

		.ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
		.ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
		.ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
		.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
			background: none;
		}

		.ant-table-pagination.ant-pagination {
			float: none;
			text-align: center;
			margin: 20px 0 4px 0;
		}

		.topBtn {
			margin-bottom: 16px;
			display: flex;
			justify-content: space-between;

			.saiBtn {
				display: flex;
			}

			.on {
				transition: color 0.3s, background 0.3s, border-color 0.3s;
				border-radius: 2px;
				padding: 6px 12px;
				cursor: pointer;
				margin-right: 10px;
				color: #262626;
				background: #ffffff;
				border: 1px solid #d9d9d9;
			}

			.rightBtn {
				display: flex;
			}
		}
	}
}
</style>
